<template>
  <div id="app">

    <sup-swiper style="margin: 0px auto;"></sup-swiper>
    <div class="sup-sale-body">
      <ElementUI
        id="elements"
        style="display:none;margin: 0px auto;"
        v-on:funk="show"
        :msshow="correct"
      ></ElementUI>
      <IssueElementUI
        id="IssueElementUIs"
        style="display:none;margin: 0px auto;"
        v-on:funks="showsy"
      ></IssueElementUI>
      <MoreElementUI id="more" style="display:none;margin: 0px auto;" v-on:morefunk="showmore"></MoreElementUI>
      <div id="body" style="display:block;margin: 0px auto;">
        <tender-center v-on:func="showm"></tender-center>
      </div>
      <div id="notice" style="display:block;margin: 0px auto;">
        <notice-centre v-on:funck="shows"></notice-centre>
      </div>
    </div>
    <div id="enquiry" style="display:block;margin: 0px auto;">
      <enquiry-centre v-on:funcc="showcc"></enquiry-centre>
    </div>
    <div id="price" style="display:block;margin: 0px auto;">
      <price-centre v-on:funckk="showkk"></price-centre>
    </div>
    <div id="contact" style="display:block;margin: 0px auto;">
      <contact-centre ></contact-centre>
    </div>
    <bottombox style="margin: 0px auto;"></bottombox>
  </div>
</template>  

<script>

import SupSwiper from "./SupSwiper.vue";
import tenderCenter from "./TenderCenter.vue";
import noticeCentre from "./NoticeCentre.vue";
import enquiryCentre from "./EnquiryCentre.vue";
import priceCentre from "./PriceCentre.vue";
import contactCentre from "./ContactCentre.vue";
import ElementUI from "./ElementUI.vue";
import IssueElementUI from "./IssueElementUI.vue";
import MoreElementUI from "./MoreElementUI";
import bottombox from "./Bottombox.vue";

export default {
  components: {

    "sup-swiper": SupSwiper,
    "tender-center": tenderCenter,
    "notice-centre": noticeCentre,
    "enquiry-centre": enquiryCentre,
    "price-centre": priceCentre,
    "contact-centre": contactCentre,
    ElementUI,
    IssueElementUI,
    MoreElementUI,
    bottombox: bottombox
  },
  data() {
    return {
      msg: "",
      showfs: "",
      correct: ""
    };
  },
  methods: {

     //多语言刷新
    //  childrenClick(){
    //    console.log('Refresh')
    //   this.$forceUpdate(); 
    //  },

    //子组件向父组件传值
    showm(data1, data2, data3) {
      this.msg = data1;
      this.showfs = data2;
      this.correct = data3;
      if (this.msg == false) {
        document.getElementById("body").style.display = "none";
        document.getElementById("notice").style.display = "none";
        document.getElementById("enquiry").style.display = "none";
        document.getElementById("price").style.display = "none";
        document.getElementById("contact").style.display = "none";
        document.getElementById("elements").style.display = "block";
        document.getElementById("IssueElementUIs").style.display = "none";
        document.getElementById("more").style.display = "none";
      }
      if (this.showfs == false) {
        document.getElementById("body").style.display = "none";
        document.getElementById("notice").style.display = "none";
        document.getElementById("enquiry").style.display = "none";
        document.getElementById("price").style.display = "none";
        document.getElementById("contact").style.display = "none";
        document.getElementById("elements").style.display = "none";
        document.getElementById("IssueElementUIs").style.display = "none";
        document.getElementById("more").style.display = "block";
      }
    },
    shows(data) {
      this.msg = data;
      if (this.msg == false) {
        document.getElementById("body").style.display = "none";
        document.getElementById("notice").style.display = "none";
        document.getElementById("enquiry").style.display = "none";
        document.getElementById("price").style.display = "none";
        document.getElementById("contact").style.display = "none";
        document.getElementById("elements").style.display = "none";
        document.getElementById("IssueElementUIs").style.display = "block";
        document.getElementById("more").style.display = "none";
      }
    },
    showcc(data) {
      this.msg = data;
      if (this.msg == false) {
        document.getElementById("body").style.display = "none";
        document.getElementById("notice").style.display = "none";
        document.getElementById("enquiry").style.display = "none";
        document.getElementById("price").style.display = "none";
        document.getElementById("contact").style.display = "none";
        document.getElementById("elements").style.display = "block";
        document.getElementById("IssueElementUIs").style.display = "none";
        document.getElementById("more").style.display = "none";
      }
    },
    showkk(data) {
      this.msg = data;
      if (this.msg == false) {
        document.getElementById("body").style.display = "none";
        document.getElementById("notice").style.display = "none";
        document.getElementById("enquiry").style.display = "none";
        document.getElementById("price").style.display = "none";
        document.getElementById("contact").style.display = "none";
        document.getElementById("elements").style.display = "block";
        document.getElementById("IssueElementUIs").style.display = "none";
        document.getElementById("more").style.display = "none";
      }
    },
    show(data) {
      this.msg = data;
      if (this.msg == true) {
        document.getElementById("body").style.display = "block";
        document.getElementById("notice").style.display = "block";
        document.getElementById("enquiry").style.display = "block";
        document.getElementById("price").style.display = "block";
        document.getElementById("contact").style.display = "block";
        document.getElementById("elements").style.display = "none";
        document.getElementById("IssueElementUIs").style.display = "none";
        document.getElementById("more").style.display = "none";
      }
    },
    showsy(data) {
      this.msg = data;
      if (this.msg == true) {
        document.getElementById("body").style.display = "block";
        document.getElementById("notice").style.display = "block";
        document.getElementById("enquiry").style.display = "block";
        document.getElementById("price").style.display = "block";
        document.getElementById("contact").style.display = "block";
        document.getElementById("elements").style.display = "none";
        document.getElementById("IssueElementUIs").style.display = "none";
        document.getElementById("more").style.display = "none";
      }
    },
    showmore(data) {
      this.msg = data;
      if (this.msg == true) {
        document.getElementById("body").style.display = "block";
        document.getElementById("notice").style.display = "block";
        document.getElementById("enquiry").style.display = "block";
        document.getElementById("price").style.display = "block";
        document.getElementById("contact").style.display = "block";
        document.getElementById("elements").style.display = "none";
        document.getElementById("IssueElementUIs").style.display = "none";
        document.getElementById("more").style.display = "none";
      }
    }
  }

};
</script>

<style scoped lang="scss">
.sup-sale-body {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  margin-top: 64px;
}
</style>
